import { Box } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { red } from "@mui/material/colors";
import { sensorIconStyle } from "../../../styles/commonStyles";
import { getSensorIcon } from "../../muiTabs/utils";
import { isSensorDisconnected } from "../../../utils/sensorStatusUtils";
import { isWeatherStation } from "../../../config/sensors.config";

const SensorIcon = ({ instrumentsData }) => {
  const isDisconnected = isSensorDisconnected(instrumentsData);
  const weatherStation = isWeatherStation(instrumentsData);
  const sensorIcon = getSensorIcon(instrumentsData);
  const IconComponent =
    isDisconnected && !weatherStation ? InfoOutlined : sensorIcon.icon;
  const bgColor = isDisconnected ? red[400] : sensorIcon.bgColor;
  const iconColor = isDisconnected ? red[50] : sensorIcon.iconColor;

  return (
    <Box sx={sensorIconStyle(bgColor)}>
      <IconComponent sx={{ color: iconColor }} />
    </Box>
  );
};

export default SensorIcon;
